<p-editor [formControl]="formControl" [style]="{ height: '320px' }"></p-editor>
